import DefaultMealPlan from './DefaultMealPlan';

export default DefaultMealPlan;
